export default "__VITE_ASSET__CV0j6v7k__"